export class ProdutoGenericoFormModel {
    constructor(
        public xProd: string = '',
        public qCom: string = '',
        public vUnCom: string = ''
    ) { }
}